export default function changeLang() {
    const changeLangElement = document.getElementById("changeLang");
    const langFunctionElement = document.getElementById("langFunction");
    const routeCurrentElement = document.getElementById("routeCurrent");

    if (changeLangElement && langFunctionElement && routeCurrentElement) {
        changeLangElement.addEventListener("change", function () {
            const lang = changeLangElement.value;
            const url = langFunctionElement.value;

            fetch(url, {
                method: "POST",
                headers: {
                    "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ lang: lang }),
            })
                .then((response) => {
                    if (!response.ok) {
                        throw new Error(`Network response was not ok: ${response.statusText}`);
                    }
                    return response.json();
                })
                .then((data) => {
                    if (data.status) {
                        const urlCurrent = routeCurrentElement.value;
                        window.location.replace(urlCurrent);
                    } else {
                        console.error("Language change failed:", data);
                    }
                })
                .catch((error) => {
                    console.error("Error changing languages:", error);
                });
        });
    }
}
